export default "/kiban/_next/static/images/diamond-403283bb9a2c803cb40ea317f7574e01.gif";